import { useMutation } from "@tanstack/react-query";
import { deleteMediaImages } from "../services/images.service";

export const useDeleteImages = () => {
  return useMutation({
    mutationFn: ({ imageIds }: { imageIds: string[] }) => {
      const joinedImageIds = imageIds.join(",");
      return deleteMediaImages(joinedImageIds);
    },
  });
};
